import { useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
  faGear,
  faGripDotsVertical,
} from "@fortawesome/pro-solid-svg-icons";
import { QuestionsTable } from "./QuestionsTable";
import type { Question, Section } from "./types";

export interface SectionCardProps {
  section: Section;
  questions: Question[];
  onRename: (section: Section) => void;
  onDelete: (section: Section) => void;
  onAddQuestion: (section: Section) => void;
  onEditQuestion: (q: Question) => void;
  selectedIds: string[];
  setSelectedIds: (ids: string[]) => void;
  // Optional dnd-kit sortable wiring — omit for non-draggable rendering
  setNodeRef?: (el: HTMLElement | null) => void;
  style?: React.CSSProperties;
  dragHandleProps?: Record<string, any>;
  draggable?: boolean;
}

export const SectionCard = ({
  section,
  questions,
  onRename,
  onDelete,
  onAddQuestion,
  onEditQuestion,
  selectedIds,
  setSelectedIds,
  setNodeRef,
  style,
  dragHandleProps,
  draggable = false,
}: SectionCardProps): JSX.Element => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="questionnaire-section" ref={setNodeRef} style={style}>
      <div className="questionnaire-section__header">
        <div className="questionnaire-section__title-group">
          {draggable && (
            <span className="questionnaire-section__grip" {...dragHandleProps}>
              <FontAwesomeIcon icon={faGripDotsVertical} />
            </span>
          )}
          <span className="questionnaire-section__title">{section.name}</span>
          <Dropdown>
            <Dropdown.Toggle
              as="button"
              className="btn btn-link p-0 questionnaire-section__gear"
              aria-label={`Section menu ${section.name}`}
            >
              <FontAwesomeIcon icon={faGear} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => onRename(section)}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item
                className="text-danger"
                onClick={() => onDelete(section)}
              >
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <Button
          variant="link"
          className="p-0 questionnaire-section__chevron"
          aria-label={`Toggle ${section.name}`}
          onClick={() => setExpanded((e) => !e)}
        >
          <FontAwesomeIcon icon={expanded ? faChevronUp : faChevronDown} />
        </Button>
      </div>
      {expanded && (
        <div className="questionnaire-section__body">
          <QuestionsTable
            questions={questions}
            onEdit={onEditQuestion}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            draggable={draggable}
          />
          <button
            type="button"
            className="questionnaire-section__add-question"
            onClick={() => onAddQuestion(section)}
          >
            + Add Question
          </button>
        </div>
      )}
    </div>
  );
};

export default SectionCard;
